import type { IBotNetworkInterface } from '../types/bot_interface';
import type { IBotNetwork, IToBotMessagePacket, IFeedback, t_network_types, t_socket_state } from '../types/network';

import { MessagingFacade } from '../facades/messaging_facade';

/**
 * generates the same content for every question locally for demo purposes
 */
export class NetworkDemo implements IBotNetwork {
  /**
   * - receiving - before we send
   * - ready - at the start and after we send
   */
  state: 'ready' | 'receiving' = 'ready';

  constructor(public stateInterface: IBotNetworkInterface, public messagingFacade: MessagingFacade) {}

  /**
   * it is never a none connection because this does not exist as a valid option
   */
  static isOf(uri: string): boolean {
    return uri.match(/^demo/) != null;
  }

  async startup() {
    return this;
  }

  async shutdown() {
    return this;
  }

  public get inStreaming(): boolean {
    return this.state !== 'ready';
  }

  async send(packet: IToBotMessagePacket) {
    this.state = 'receiving';

    return new Promise<IToBotMessagePacket>((resolve) => {
      setTimeout(() => {
        const messagingFacade = this.messagingFacade;
        const message = [
          `This is just an internal demo.`,
          `<button data-method="pushTo" data-parameters='["This message was written by the server", "from-bot"]'>Button From Server</button>`,
          `
    | Type | Definition |
    | ---- | ---------- |
    | A    | Def for A.  |
    | B    | Def for B, but we have quite a lot to save about this definition.  |`,
          '',
          '### Title H3',
          '### Title H4',
          '',
          'This is <strong>even more</strong> text. Also you can go to <a href="www.google.com">Google</a>, but please do not'
        ].join('\n');

        messagingFacade.writeMessageFromBot(message);
        messagingFacade.notifyStreamingDone('12345');

        this.state = 'ready';
        resolve(packet);
      }, (Math.random() / 3) * 1000);
    });
  }

  ofType(type: t_network_types): type is 'demo' {
    return type === 'demo';
  }

  sendFeedback(feedback: IFeedback, uri?: string) {
    return Promise.resolve({});
  }

  /**
   * @returns connection state
   */
  getState(): t_socket_state {
    return 'open';
  }
}
